import { getDocHeight, getCookie  } from "./helpers/utils"

const NAME = "gama-bulletins"
const VERSION = "1.0.0"

const ACTION = "gama_loadmorebulletins"

const CAPTION_CLASS = "caption"
const GRID_CLASS = "bulletins-grid"
const ITEM_CLASS = "grid-item"

const GRID_SELECTOR = "." + GRID_CLASS
const ITEM_SELECTOR = "." + ITEM_CLASS
const LOADMORE_SELECTOR = ".load-more"
const QUERY_SELECTOR = ".filters"

const EVENT_SCROLL = 'scroll'
const EVENT_DOMLOADED =  'DOMContentLoaded'

const PAGED = "bulletins_paged"

const GRID_SIZES = [
  "box-1x1",
  "box-1x2",
  "box-2x1",
  "box-2x2",
]

class GamaBulletins {
  constructor() {
    this._perpage = 8
    this._request = null
    this._window = window
    this._document = document
    this._LoadMore = document.querySelector(LOADMORE_SELECTOR)
    this._query = document.querySelector(QUERY_SELECTOR)

  }

  // public
  async query(pckr) {
    let dt = new FormData()
    dt.append('action', ACTION)
    dt.append('per_page', this._perpage)
    dt.append('paged', sessionStorage.getItem(PAGED) )

    this._request = await fetch( ajax.url, {
      method: 'POST',
      credentials: "same-origin",
      cache: "no-cache",
      body: dt,
    })
    .then( response => response.json() )
    .then( json => {
      sessionStorage.setItem(PAGED, json.paged)
      let obj = json.data
      console.log("obj", obj)
      for (var i = 0; i < obj.length; i++) {
        let item = obj[i]
        let box = document.createElement("div")
        let image = document.createElement("div")
        let caption = document.createElement("div")
        let textWrapper = document.createElement("div")
        let text = document.createElement("p")
        let year = document.createElement("p")
        let donor = document.createElement("p")
        let projects = document.createElement("span")
        let a = document.createElement("a")
        a.href = item.url
        textWrapper.style.height = "82px"
        textWrapper.style.width = "calc(100% - 10px)"
        textWrapper.style.position = "absolute"
        textWrapper.style.top = "200px"
        textWrapper.style.left = "5px"
        textWrapper.style.right = "5px"
        textWrapper.style.textAlign = "center"
        text.innerHTML = item.title
        year.innerHTML = item.year
        donor.innerHTML = item.donor
        //console.log(item.projects)
        textWrapper.appendChild(text)
        textWrapper.appendChild(year)
        textWrapper.appendChild(donor)
        textWrapper.appendChild(projects)
        box.classList.add(ITEM_CLASS)
        box.classList.add(GRID_SIZES[item.size])
        image.style.backgroundImage = "url('" + item.thumbnail + "')"
        image.style.backgroundRepeat = "no-repeat"
        image.style.backgroundSize = "contain"
        image.style.backgroundPosition = "center"
        image.style.backgroundOrigin = "content-box"
        image.style.height = "230px"
        image.style.margin = "5px"
        caption.classList.add(CAPTION_CLASS)
        a.appendChild(caption)
        box.appendChild(image)
        box.appendChild(a)

        this._document.querySelector(GRID_SELECTOR).appendChild(box);
        pckr.appended(box)
      }
      this._LoadMore.style.visibility = "hidden";
    })
    .catch( (error) => {
      // silence is golden
    })
    .then( () => {
      pckr.layout()
    })

  }

  static get NAME() {
    return NAME
  }

  static get VERSION() {
    return VERSION
  }

  static init(){
    let q = new GamaBulletins()
    let grid = document.querySelector(GRID_SELECTOR)
    let _debounce
    let pckr = require('packery')
    if (grid) {
      pckr = new Packery( GRID_SELECTOR, {
        itemSelector: ITEM_SELECTOR,
        percentPosition: true,
      });
      clearTimeout(_debounce)
      _debounce = setTimeout(() => {
        q.query(pckr)
        LoadMore.style.visibility = "visible";
      }, 500)
    }
    window.addEventListener(EVENT_SCROLL, function(e) {
      if (grid) {
        if ((window.innerHeight + window.scrollY) >= getDocHeight(document)) {
          clearTimeout(_debounce)
          _debounce = setTimeout(() => {
            q.query(pckr)
            LoadMore.style.visibility = "visible";
          }, 500)
        }
      }
    }, { passive: true });
  }
}

window.addEventListener(EVENT_DOMLOADED, (e) => {
  sessionStorage.setItem(PAGED, 1)
  GamaBulletins.init()
});

export default GamaBulletins
